__turbopack_context__.v({
  "suggestion": "search-suggestions-module-scss-module__lA0C_q__suggestion",
  "title": "search-suggestions-module-scss-module__lA0C_q__title",
  "wrapper": "search-suggestions-module-scss-module__lA0C_q__wrapper",
});
